<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <h4 class="text-uppercase mb-0">Recommended Profiles</h4>
          <a href="/help/knowledgebase?section=rcmnd-prfls" target="_blank">
            <img
              src="/img/icons/ic_info.svg"
              alt="About Recommended Profiles"
              class="ms-2"
          /></a>
        </div>
      </div>

      <div class="col-lg-9 col-12 mt-3">
        <div class="card h-100">
          <profile-types
            v-if="!commanderLogin && displayProfileTypes && profileTypes.length > 0"
            :data="profileTypes"
            :selected-profile-type-id="selectedProfileTypeId"
            class="mt-3"
            @selected-profile-type="
              (selectedValue) => (selectedProfileType = selectedValue)
            "
          />

          <div class="card-header">
            <div class="row">
              <div v-if="commanderLogin">
                 <h5 class="text-capitalize">
                   The suitability of individuals is determined through analysis of their wearable fitness and wellness data.
                </h5>
              </div>
              <div v-else-if="displayProfileTypes" class="col-12">
                <h5 class="text-capitalize">
                  {{
                    selectedProfileType
                      ? selectedProfileType.dna_profile_name
                      : ""
                  }}
                  Candidates
                </h5>
                <div class="text-xs text-lighter">
                  The suitability of the individuals for a
                  {{
                    selectedProfileType
                      ? selectedProfileType.dna_profile_name
                      : ""
                  }}
                  vocation. This calculation is based on DNA and wellness data.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="d-flex flex-row justify-content-start mt-3">
                <div
                  v-for="l in legend"
                  :key="l.confidence"
                  class="text-xs text-capitalize me-4"
                >
                  <div
                    class="square me-1"
                    :class="`legend-${l.confidence}`"
                  ></div>
                  {{ l.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="card-body bg-darker">
            <div class="d-flex flex-row">
              <div class="w-30">
                <div id="sorting-section">
                  <el-dropdown placement="bottom-start">
                    <el-button class="sort-button">
                        <icon-sort></icon-sort>
                        <span style="padding-left: 0.5rem;">Sort</span>
                    </el-button>
                    <template #dropdown>
                      <el-dropdown-menu class="sort-drop-down" style="background-color: #1f2628;">
                        <el-dropdown-item>
                          <div class="d-flex flex-row justify-content-between sort-item">
                            <div class="w-85">
                              <span>Profile Score</span>
                            </div>
                            <div class="sort-icon">
                              <div class="d-flex flex-column">
                                <icon-sort-dsc-selected v-if="this.selectedSort == 'PROFILESCORE_ASC'" />
                                <icon-sort-dsc v-else @click="sortProfile('PROFILESCORE_ASC', 'profile_score', 'asc')"/>
                                <icon-sort-asc-selected v-if="this.selectedSort == 'PROFILESCORE_DSC'" />
                                <icon-sort-asc v-else @click="sortProfile('PROFILESCORE_DSC', 'profile_score', 'desc')"/>
                              </div>
                            </div>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="!commanderLogin">
                          <div class="d-flex flex-row justify-content-between sort-item">
                            <div class="w-85">
                              <span>DNA Score</span>
                            </div>
                            <div class="sort-icon">
                              <div class="d-flex flex-column">
                                <icon-sort-dsc-selected v-if="this.selectedSort == 'DNASCORE_ASC'" />
                                <icon-sort-dsc v-else @click="sortProfile('DNASCORE_ASC', 'dna_score', 'asc')" />
                                <icon-sort-asc-selected v-if="this.selectedSort == 'DNASCORE_DSC'" />
                                <icon-sort-asc v-else @click="sortProfile('DNASCORE_DSC', 'dna_score', 'desc')" />
                              </div>
                            </div>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="d-flex flex-row justify-content-between sort-item">
                            <div class="w-85">
                              <span>Wellness Score</span>
                            </div>
                            <div class="sort-icon">
                              <div class="d-flex flex-column">
                                <icon-sort-dsc-selected v-if="this.selectedSort == 'WELLNESSSCORE_ASC'" />
                                <icon-sort-dsc v-else @click="sortProfile('WELLNESSSCORE_ASC', 'wellness_score', 'asc')" />
                                <icon-sort-asc-selected v-if="this.selectedSort == 'WELLNESSSCORE_DSC'" />
                                <icon-sort-asc v-else @click="sortProfile('WELLNESSSCORE_DSC', 'wellness_score', 'desc')" />
                              </div>
                            </div>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item class="align-middle" style="border-top:#7db2ae 0.1rem solid;">
                          <div class="clear-sort" @click="resetSort()">Clear</div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
              </div>
              <div class="d-flex align-self-end justify-content-end w-70">
                <argon-input
                  id="search"
                  name="search"
                  :value="searchText"
                  type="text"
                  placeholder="Search by name..."
                  aria-label="Search"
                  class="me-3 mb-0 w-25"
                  @input="(event) => (searchText = event.target.value)"
                  @keyup.enter="search()"
                />
                <profile-confidence-dropdown
                  @selected-confidence-id="
                    (selectedValue) => (selectedConfidenceLevel = selectedValue)
                  "
                />
              </div>
            </div>
            <div v-if="candidates.count > 0" class="row">
              <div
                v-for="candidate in candidates.rows"
                :key="candidate.udid"
                class="col-xxxl-3 col-lg-4 col-sm-6 mt-3"
              >
                <a href="#">
                  <user-profile-card
                    :candidate="candidate"
                    :user="candidate.user[0]"
                    :show-dna="!commanderLogin"
                    :class="
                      selectedCandidate == candidate ? 'bg-dark' : 'transparent'
                    "
                    @click="updateSelectedCandidate(candidate)"
                  />
                </a>
              </div>
            </div>
            <div v-else class="text-muted pt-5">
              No profiles found for selected filters.
            </div>
          </div>

          <div class="card-footer paginator">
            <div class="d-flex justify-content-between align-items-center">
              <span class="ms-3 text-muted"
                >{{ candidates.count || 0 }} record(s)</span
              >
              <app-pagination
                :records="candidates.count"
                :page-size="pageSize"
                :page="page"
                @update-page-selection="
                  (selectedValue) => updatePageSelection(selectedValue)
                "
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-12 mt-3">
        <user-profile-details
          v-if="selectedCandidate"
          :dna-profile-id="selectedCandidate.dna_profile_id != null ? selectedCandidate.dna_profile_id : 'NA'"
          :confidence="selectedCandidate.confidence"
          :user="selectedCandidate.user[0]"
          :selected-candidate="selectedCandidate"
          :display-dna="!commanderLogin && displayDna"
        />
      </div>
    </div>
  </div>
</template>
<script>

import {useRoute} from "vue-router";
import Constants from "@/helpers/constants";
import ArgonInput from "@/shared/Controls/ArgonInput.vue";
import IconSort from "@/shared/Controls/Icons/IconSort.vue";
import IconSortAsc from "@/shared/Controls/Icons/IconSortAsc.vue";
import IconSortAscSelected from "@/shared/Controls/Icons/IconSortAscSelected.vue";
import IconSortDsc from "@/shared/Controls/Icons/IconSortDsc.vue";
import IconSortDscSelected from "@/shared/Controls/Icons/IconSortDscSelected.vue";
import ProfileTypes from "../components/ProfileTypes.vue";
import ProfileConfidenceDropdown from "../components/ProfileConfidenceDropdown.vue";
import UserProfileCard from "./components/profiler/UserProfileCard.vue";
import UserProfileDetails from "./components/profiler/UserProfileDetails.vue";

export default {
  name: "AiProfiler",
  components: {
    ArgonInput,
    ProfileTypes,
    ProfileConfidenceDropdown,
    UserProfileCard,
    UserProfileDetails,
    IconSort,
    IconSortAsc,
    IconSortAscSelected,
    IconSortDsc,
    IconSortDscSelected,
  },
  data() {
    return {
      bgCard: "transparent",
      searchText: "",
      selectedProfileType: null,
      selectedConfidenceLevel: null,
      selectedCandidate: null,
      page: 1,
      pageSize: 12,
      minConfidence: 0,
      maxConfidence: 100,
      legend: [
        {
          name: "High: Above 70%",
          confidence: "high",
          id: 1,
        },
        {
          name: "Medium: 50% to 69%",
          confidence: "medium",
          id: 2,
        },
        {
          name: "Low: Below 50%",
          confidence: "low",
          id: 3,
        },
      ],
      profileTypes: [],
      candidates: [],
      queryProfileType: null,
      selectedSort: 'PROFILESCORE_DSC',
      sortType: 'wellness_score',
      sortOrder: 'desc',
      selectedProfileTypeId: -1,
      commanderLogin: false,
      displayDna: Constants.DISPLAY_DNA,
      displayProfileTypes: Constants.DISPLAY_PROFILE_TYPES,
    };
  },
  watch: {
    searchText() {
      if (this.searchText.trim().length == 0)
        this.getCandidatesForSelectedProfileType();
    },
    selectedProfileType() {
      this.page = 1;
      this.getCandidatesForSelectedProfileType();
    },
    selectedConfidenceLevel() {
      this.minConfidence = 0;
      this.maxConfidence = 100;

      if (this.selectedConfidenceLevel == 1) {
        this.minConfidence = 70;
      } else if (this.selectedConfidenceLevel == 2) {
        this.minConfidence = 50;
        this.maxConfidence = 69;
      } else if (this.selectedConfidenceLevel == 3) {
        this.maxConfidence = 49;
      }
      this.page = 1;
      this.getCandidatesForSelectedProfileType();
    },
  },
  created() {
    this.getProfileTypes();
  },
  mounted() {
    this.selectedCandidate = this.candidates[0];
    const profile = useRoute().query.profile;
    if(profile && profile != 'N/A') {
      this.queryProfileType = profile;
    }
    if(this.queryProfileType) {
      let filteredProfileTypes = this.profileTypes.filter((element) => {
        return element.dna_profile_name.toLowerCase() == this.queryProfileType.toLowerCase()});
      this.selectedProfileType = filteredProfileTypes[0];
    }
    this.isCommanderLogin();
    if(!this.displayProfileTypes) {
      this.getCandidatesForSelectedProfileType();
    }
  },
  methods: {
    search() {
      if (this.searchText.trim().length > 0) {
        this.page = 1;
        this.getCandidatesForSelectedProfileType();
      }
    },
    getProfileTypes() {
      this.$store
        .dispatch("list/getProfileList", {
          sort: "dna_profile_name",
          order: "asc",
        })
        .then(({ data }) => {
          if (data && data.length > 0) {
            this.profileTypes = data;
            if(this.queryProfileType) {
              let filteredProfileTypes = this.profileTypes.filter((element) => {
                return element.dna_profile_name.toLowerCase() == this.queryProfileType.toLowerCase()});
              this.selectedProfileType = filteredProfileTypes[0];
            } else {
              this.selectedProfileType = this.profileTypes[0];
            }
            this.selectedProfileTypeId = this.selectedProfileType ? this.selectedProfileType.dna_profile_id : -1;
          }
        });
    },
    getCandidatesForSelectedProfileType() {
      if (this.selectedProfileType) {
        this.$store
          .dispatch("data/candidatesForProfileType", {
            dna_profile_id: this.selectedProfileType.dna_profile_id,
            sort: this.sortType,
            order: this.sortOrder,
            page: this.page,
            page_size: this.pageSize,
            min_confidence: this.minConfidence || 0,
            max_confidence: this.maxConfidence || 100,
            search_term: this.searchText || "",
            platoon_id: -1,
            section_id: -1,
          })
          .then(({ data }) => {
            if (data && data.count > 0) {
              this.candidates = data;
              this.selectedCandidate = this.candidates.rows[0];
            } else {
              this.candidates = [];
              this.selectedCandidate = null;
            }
          });
      }
    },
    updatePageSelection(selectedPage) {
      this.page = selectedPage;
      this.getCandidatesForSelectedProfileType();
    },
    updateSelectedCandidate(candidate) {
      this.selectedCandidate = candidate;
    },
    sortProfile(selectedSort, sortType ,sortOrder) {
      this.selectedSort = selectedSort;
      this.sortType = sortType;
      this.sortOrder = sortOrder;
      this.page = 1;
      this.getCandidatesForSelectedProfileType();
    },
    resetSort() {
      this.sortType = 'profile_score';
      this.sortOrder = 'desc';
      this.selectedSort = 'PROFILESCORE_DSC';
      this.getCandidatesForSelectedProfileType();
    },
    isCommanderLogin() {
      let loggedInUser = this.$store.getters["auth/getLoggedInUser"]();
      if(loggedInUser && loggedInUser.role 
          && loggedInUser.role.role_id == Constants.ROLES.PLATOON_COMMANDER) {
         this.commanderLogin = true;
      } else {
        this.commanderLogin = false;
      }
      return this.commanderLogin;
    }
  },
};
</script>

<style lang="scss" scoped>
.square {
  width: 10px;
  height: 10px;
}
.legend {
  &-high {
    background-color: $profile-high-confidence !important;
  }
  &-medium {
    background-color: $profile-medium-confidence !important;
  }
  &-low {
    background-color: $white !important;
  }
} 
.sort-icon {
  margin-left: 0.5rem; 
  width: 15%;
}
.sort-item {
  width: 100%;
}
.clear-sort {
  color: #7db2ae;
}
.sort-drop-down {
  padding: 0.5rem;
  width: 12rem
}
.sort-button:hover {
  color: #7db2ae;
}

.sort-button:hover .icon-sort{
  fill: #7db2ae;
}

.sort-button:hover .icon-sort:hover svg path {
  fill: #7db2ae;
}
</style>
